import React from "react";
import { useSection } from "@/context/SiteContext";
import { resolveImageUrl } from "@/lib/site";

export default function About() {
  const about = useSection("about");
  const img = resolveImageUrl(about.image_url);

  return (
    <section id="om" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center bg-[var(--surface-alt)] rounded-3xl p-6 sm:p-10 lg:p-16">
          <div className="relative rounded-2xl overflow-hidden h-[340px] sm:h-[440px] lg:h-[520px] order-2 lg:order-1 bg-white">
            {img && <img src={img} alt={about.title_line1 || "Om oss"} className="w-full h-full object-cover" />}
          </div>
          <div className="order-1 lg:order-2 space-y-6">
            <span className="inline-block text-xs uppercase tracking-[0.22em] font-semibold text-[var(--primary)]">
              {about.eyebrow || "Om oss"}
            </span>
            <h2 className="font-serif-display text-4xl sm:text-5xl font-black tracking-tight leading-[1.05]">
              {about.title_line1} <br />
              <span className="italic font-medium">{about.title_italic}</span>
            </h2>
            <p className="text-lg text-[var(--text-muted)] leading-relaxed">{about.paragraph_1}</p>
            {about.paragraph_2 && (
              <p className="text-lg text-[var(--text-muted)] leading-relaxed">{about.paragraph_2}</p>
            )}

            <div className="grid grid-cols-3 gap-4 pt-6 border-t border-[var(--border)]">
              {[1, 2, 3].map((i) => {
                const v = about[`stat_${i}_value`];
                const l = about[`stat_${i}_label`];
                if (!v && !l) return null;
                return (
                  <div key={i}>
                    <div className="font-serif-display text-3xl sm:text-4xl font-black text-[var(--primary)]">{v}</div>
                    <div className="text-xs sm:text-sm text-[var(--text-muted)] mt-1">{l}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
